/**
 * Labstep
 *
 * @module components/Experiment/Form/ShowEdit/EndedAt
 * @desc Showing experiment.ended_at + allow for update
 */

import { FormShowEditDateContainer as FormShowEditDate } from 'labstep-web/core/Form/ShowEdit/Date';
import type React from 'react';
import type { ExperimentFormShowEditEndedAtProps } from './types';

export const ExperimentFormShowEditEndedAt: React.FC<
  ExperimentFormShowEditEndedAtProps
> = ({ experiment }) => {
  return (
    <FormShowEditDate
      dataCy="components/Experiment/Form/ShowEdit/EndedAt"
      entity={experiment}
      field="ended_at"
      label="completion"
      dateTimePickerOptions={{ minDate: experiment.started_at }}
    />
  );
};
